import React from 'react'
import Fragment from '../common/fragment'


function FragmentCC(props) {
  return (
    <Fragment pos="ccc" {...props}>
      <p>
Un Cristo Negro sumergido en la Oscuridad de la Noche. Oculto para los ojos
ciegos de sus captores.
      </p>
    </Fragment>
  )
}


export default FragmentCC
